import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../../Config';
import { notification } from 'antd';

const initialState = {
  isLoading: false,
  isError: null,
  errors: [],
  isSuccess: false,
  message: '',
};

export const deleteCampaign = createAsyncThunk(
  'Campaign/delete-campaign',
  async ({ id, onSuccess }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.delete(`${BASE_URL}/api/campaign/campaign/${id}`);
      response?.data?.message && notification.success({ message: 'Success', description: response?.data?.message });
      onSuccess && onSuccess();
      return response?.data;
    } catch (error) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.errors[0]?.message || 'Network error',
      });
      return rejectWithValue(error?.response?.data);
    }
  }
);

const deleteCampaignSlice = createSlice({
  name: 'Delete Campaign',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(deleteCampaign.pending, (state) => {
      state.isLoading = true;
      state.isSuccess = false;
    });
    builder.addCase(deleteCampaign.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.errors = [];
      state.isSuccess = action?.payload?.success;
      state.message = action?.payload?.message;
    });
    builder.addCase(deleteCampaign.rejected, (state, action) => {
      state.isLoading = false;
      state.errors = action.payload?.errors || [];
      state.isError = true;
    });
  },
});

export default deleteCampaignSlice?.reducer;
